// Category display labels mapping
// Maps raw database values to pretty display names with emojis

export const categoryLabels: { [key: string]: string } = {
  auto_repair: '🔧 Auto Repair',
  auto_body: '🚗 Auto Body & Paint',
  auto_parts: '⚙️ Auto Parts',
  transmission: '🏎️ Transmission',
  towing: '🚛 Towing',
  plumbing: '🔧 Plumbing',
  electrical: '⚡ Electrical',
  hvac: '❄️ HVAC',
  roofing: '🏠 Roofing',
  gutters: '🌧️ Gutters',
  siding: '🏚️ Siding',
  awnings: '⛱️ Awnings',
  painting: '🎨 Painting',
  flooring: '🪵 Flooring',
  remodeling: '🏗️ Remodeling',
  concrete: '🧱 Concrete',
  patios: '🪴 Patios / Patio Covers',
  landscaping: '🌿 Landscaping',
  fencing: '🏡 Fencing',
  fence_deck: '🪚 Fence & Deck',
  pressure_washing: '💦 Pressure Washing',
  appliance_repair: '🔌 Appliance Repair',
  general_contractor: '🔨 General Contractor',
  windows_doors: '🪟 Windows & Doors',
  handyman: '🛠️ Handyman',
  tree_service: '🌳 Tree Service',
  pool: '🏊 Pool Service',
  house_cleaning: '🧹 House Cleaning',
  carpet_cleaning: '🧽 Carpet Cleaning',
  pest_control: '🐜 Pest Control',
  junk_removal: '🚚 Junk Removal',
  mold_remediation: '🦠 Mold Removal / Remediation',
  water_damage_restoration: '💧 Water Damage Restoration',
  dog_training: '🐕 Dog Training',
  pet_grooming: '✂️ Pet Grooming',
  pet_sitting: '🐾 Pet Sitting',
  pet_boarding: '🏨 Pet Boarding',
  veterinary: '🏥 Veterinary',
  legal: '⚖️ Legal',
  accounting: '📊 Accounting & Tax',
  insurance: '🛡️ Insurance',
  real_estate: '🏙️ Real Estate',
  electronics: '📱 Electronics & IT',
  moving: '📦 Moving & Storage',
  catering: '🍽️ Catering & Events',
  photography: '📸 Photography',
  tutoring: '📚 Tutoring',
  other: '❓ Other',
  // Legacy values that might still be in the database
  automotive: '🔧 Automotive',
  pet_services: '🐾 Pet Services',
  home_improvement: '🏠 Home Improvement',
  services: '🔧 Services',
};

export function getCategoryLabel(raw: string): string {
  if (!raw) return 'General';
  return categoryLabels[raw] || raw.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

// Decode HTML entities like &quot; &amp; etc.
export function decodeHtmlEntities(text: string): string {
  if (!text) return '';
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}
